import {
  createExtension,
  coreExtensionData,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';

export const CustomAppLayout = createExtension({
  name: 'layout',
  attachTo: { id: 'app/root', input: 'children' },
  inputs: {
    nav: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
    content: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
  },
  output: [coreExtensionData.reactElement],
  factory: ({ inputs }) => {
    const nav = inputs.nav?.get(coreExtensionData.reactElement);
    const content = inputs.content?.get(coreExtensionData.reactElement);

    return [
      coreExtensionData.reactElement(
        <div className="min-h-screen bg-gray-50 flex flex-col">
          {nav}
          <main className="flex-grow">
            {content}
          </main>
        </div>
      ),
    ];
  },
});